export default "__VITE_ASSET__CGXbIpVU__"